import {useContext, useEffect, useState} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_TYPE_REPORT_COLUMNS, formatCountAndPrice, keysToSum} from '../../utils'
import CustomerTypeReportRow from './CustomerTypeReportRow'
import {parseCustomerTypeReportRow} from '../../parsings'
import {formatPrice, formatToIndianNumber} from '../../../../utils/common'
import CustomerTypeTableHeader from '../header/CustomerTypeTableHeader'

const CustomerTypeReportTable = () => {
  const {
    customerTypeData,
    isCustomerTypeLoading,
    onCustomerTypeSortingChange,
    customerTypeFilters,
  } = useContext(CustomerReportContext)

  const [summedState, setSummedState] = useState<any>({})

  useEffect(() => {
    const summed: any = {}

    customerTypeData.forEach((row) => {
      keysToSum.forEach((key) => {
        const sumKey = `total_${key}`
        summed[sumKey] = (summed[sumKey] || 0) + (row[key] || 0)
      })
    })

    setSummedState(summed)
  }, [customerTypeData])

  return (
    <div className='card border'>
      <div className='card-body p-7'>
        <CustomerTypeTableHeader />
        <DynamicTable
          data={customerTypeData}
          sortableColumns={CUSTOMER_TYPE_REPORT_COLUMNS}
          loading={isCustomerTypeLoading}
          TableRow={CustomerTypeReportRow}
          noDataMessage='No customer type reports found'
          onSortingChange={onCustomerTypeSortingChange}
          filters={customerTypeFilters}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerTypeReportRow}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{formatToIndianNumber(columnTotals.total_order_count)}</td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_freeship_coupon_count,
                    summedState?.total_freeship_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_sf_coupon_count,
                    summedState?.total_sf_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_sll_coupon_count,
                    summedState?.total_sll_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_5offoneorder_coupon_count,
                    summedState?.total_5offoneorder_discount
                  )}
                </td>
                <td>
                  {formatCountAndPrice(
                    summedState?.total_other_coupon_count,
                    summedState?.total_other_discount
                  )}
                </td>
                <td>{formatPrice(columnTotals.total_discount, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerTypeReportTable
